import { chowlyApi } from 'config'
import { generatePath } from 'react-router-dom'
import client from '../chowly'
import { WebsiteMetadataResponse } from './models'

export const getWebsiteMetadata = async (organizationId: string) => {
  const url = generatePath(chowlyApi.marketingWebsiteMetadata, { organizationId })
  const { data } = await client.get<WebsiteMetadataResponse>(url)
  return data
}
